import AppHeader from '../AppHeader'
import {
  MOVIE_UPLOAD_NEW, MOVIE_UPLOAD_RECOMMEND,
  MOVIE_DELETE_NEW, MOVIE_DELETE_RECOMMEND
} from '../../store/modules/mutation-types'

export default {
  name: 'service-question-movie',
  components: {
    AppHeader
  },
  data () {
    return {
      newMovieFile: null,
      recommendMovieFile: null,
      newMovieExists: false,
      recommendMovieExists: false,
      newMovieUrl: '',
      recommendMovieUrl: ''
    }
  },
  computed: {
    uploading () {
      return this.$store.getters.movieUploading
    },
    deleting () {
      return this.$store.getters.movieDeleting
    },
    apiServer () {
      return this.$store.state.config.api_method + '://' + this.$store.state.config.api_server + '/' + this.$store.state.config.api_version
    }
  },
  created () {
    this.checkMovieExistence()
  },
  methods: {
    checkMovieExistence () {
      this.newMovieUrl = this.$store.state.config.api_method + '://' + this.$store.state.config.api_server + '/new_movie.mp4?t=' + Date.now()
      this.checkVideoExists(this.newMovieUrl).then(exists => {
        this.newMovieExists = exists
      })

      this.recommendMovieUrl = this.$store.state.config.api_method + '://' + this.$store.state.config.api_server + '/recommend_movie.mp4?t=' + Date.now()
      this.checkVideoExists(this.recommendMovieUrl).then(exists => {
        this.recommendMovieExists = exists
      })
    },
    
    checkVideoExists (url) {
      return new Promise((resolve) => {
        fetch(url, { 
          method: 'HEAD',
          headers: {
            'Authorization': window.localStorage.getItem('access_token') || ''
          }
        })
        .then(response => {
          resolve(response.ok)
        })
        .catch(() => {
          resolve(false)
        })
      })
    },

    selectNewMovieFile () {
      this.$refs.newMovieInput.click()
    },

    selectRecommendMovieFile () {
      this.$refs.recommendMovieInput.click()
    },

    onNewMovieFileChange (event) {
      const file = event.target.files[0]
      if (file) {
        if (!this.validateFile(file)) {
          return
        }
        this.newMovieFile = file
      }
    },

    onRecommendMovieFileChange (event) {
      const file = event.target.files[0]
      if (file) {
        if (!this.validateFile(file)) {
          return
        }
        this.recommendMovieFile = file
      }
    },

    validateFile (file) {
      if (!file.type.startsWith('video/')) {
        alert('動画ファイルを選択してください。')
        return false
      }

      if (file.size > 262144000) {
        alert('ファイルサイズは250MB以下にしてください。')
        return false
      }

      return true
    },

    uploadNewMovie () {
      if (!this.newMovieFile) return

      const formData = new FormData()
      formData.append('movie', this.newMovieFile)

      this.$store.dispatch(MOVIE_UPLOAD_NEW, {
        data: formData,
        callback: (result) => {
          if (result.status === 'success') {
            alert('アップロードが完了しました。')
            this.newMovieFile = null
            this.$refs.newMovieInput.value = ''
            this.checkMovieExistence()
          } else {
            alert('アップロードに失敗しました。')
          }
        }
      }).catch(() => {
        alert('アップロードに失敗しました。')
      })
    },

    uploadRecommendMovie () {
      if (!this.recommendMovieFile) return

      const formData = new FormData()
      formData.append('movie', this.recommendMovieFile)

      this.$store.dispatch(MOVIE_UPLOAD_RECOMMEND, {
        data: formData,
        callback: (result) => {
          if (result.status === 'success') {
            alert('アップロードが完了しました。')
            this.recommendMovieFile = null
            this.$refs.recommendMovieInput.value = ''
            this.checkMovieExistence()
          } else {
            alert('アップロードに失敗しました。')
          }
        }
      }).catch(() => {
        alert('アップロードに失敗しました。')
      })
    },

    deleteNewMovie () {
      if (!window.confirm('最新動画を削除しますか？')) {
        return
      }

      this.$store.dispatch(MOVIE_DELETE_NEW, {
        callback: (result) => {
          if (result.status === 'success') {
            alert('削除が完了しました。')
            this.checkMovieExistence()
          } else {
            alert('削除に失敗しました。')
          }
        }
      }).catch(() => {
        alert('削除に失敗しました。')
      })
    },

    deleteRecommendMovie () {
      if (!window.confirm('オススメ動画を削除しますか？')) {
        return
      }

      this.$store.dispatch(MOVIE_DELETE_RECOMMEND, {
        callback: (result) => {
          if (result.status === 'success') {
            alert('削除が完了しました。')
            this.checkMovieExistence()
          } else {
            alert('削除に失敗しました。')
          }
        }
      }).catch(() => {
        alert('削除に失敗しました。')
      })
    },

    onNewMovieError () {
      this.newMovieExists = false
    },

    onRecommendMovieError () {
      this.recommendMovieExists = false
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/service-question-movie.js